"use client";

import { Box, Container, Card } from "@mui/material";
import { FooterContent, FooterCopyrights } from "@/components/ui";

export const Footer = () => {
  return (
    <Box component="footer" sx={{ py: 6 }}>
      <Container maxWidth="xl">
        <Card
          sx={{
            overflow: "hidden",
            borderRadius: 4,
          }}
        >
          <FooterContent />
          <FooterCopyrights />
        </Card>
      </Container>
    </Box>
  );
};
